import fileMap from './translations';
// eslint-disable-next-line eqeqeq
export const mocksupportedLocales = Object.keys(fileMap).filter((k) => k != 'global');

export async function mockService(locale) {
  const translations = await fileMap[locale];
  return { locale, translations };
}
